import { AutoComplete, Input, Tooltip, Breadcrumb, message } from "antd";
// import { t } from "i18next";
import { ActiveIcon, InactiveIcon, AddIcon } from "../../../asset/icons";
import { EditIcon, DeleteIcon, DetailIcon, SearchIcon, CloseIconSearch, AscRed, DescGrey } from "../../../asset";
import style from "./DepotConfig.module.css";
import CustomTable from "../../../component/table/CustomTable";
import PrimaryButton from "../../../component/button/PrimaryButton";
import { CustomerListColumn } from "../../../constant/tableConstant";
import DeleteConfirmationModal from "../../../component/modal/DeleteConfirmationModal";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constant/routeConstant";
import axios from "axios";
import _, { transform } from "lodash";
import ModalDelete from "../../../component/modal/ModalDelete";
import Delete from "../../../component/modal/ModalDelete";
import CustomPaging from "../../../component/pagination/pagination";
import { GROLOG_URL } from "../../../constant/apiConstant";
import Breadcumbs from '../../../component/page-components/breadcumbs/breadcumbs';
import { useDispatch, useSelector } from "react-redux";
import { onChanged } from "../../../util/Util";


const DepotList = (props) => {
  const { token, client_id, grolog_account_id, userId } = useSelector((state) => state.auth);
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const { t } = useTranslation();
  const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] =
    useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [listData, setListData] = useState([]);
  const navigate = useNavigate();
  const [showDelete, setShowDelete] = useState(false);
  const [data, setData] = useState([]);
  const [sorting, setSorting] = useState("asc");
  const [sortingBy, setSortingBy] = useState("id")
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [initiate, setInitiate] = useState();
  const [searchRecommendation, setSearchRecommedation] = useState()
  const [listRecommendation, setListRecommendation] = useState([])
  const [filter, setFilter] =useState()
  const [load, setLoad] = useState(false)  
  const [isFilter, setIsfilter] = useState(false);
  const dispatch = useDispatch()
  const api = GROLOG_URL

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { "Authorization": tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const fetchData = async (data,sort,sortBy, pages) => {
    let res = await doGet(
      `/depot-configuration?page=${pages ? pages :page}&limit=${limit}&order=${sortBy?sortBy:sortingBy} ${sort?sort:sorting}${filter ? "&filter=depot_name lk " + filter : data ? "&filter=depot_name lk "+ data : ""}&${param}`,
      token
    );
    let init = await doGet(
      `/depot-configuration/initiate?page=${pages ? pages :page}&limit=${limit}&order=${sortBy?sortBy:sortingBy} ${sort?sort:sorting}${filter ? "&filter=depot_name lk " + filter : data ? "&filter=depot_name lk "+ data : ""}&${param}`,
      token)
    setListData(res?.data?.payload?.data);
    setInitiate(init?.data?.payload?.data);
  };

  useEffect(() => {
    onChanged(dispatch, false)
    fetchData();
  }, [page,limit,filter]);

  const handleEdit = (id) => {
    navigate(ROUTES.DEPOT_CONFIG.EDIT, { state: id });
  };

  const handleDetail = (id) => {
    navigate(ROUTES.DEPOT_CONFIG.DETAIL, { state: id });
  };

  const handlePagination = (a,b)=>{
    if (a && b) {
      setPage(a)
      setLimit(b)
    } else {
     
    }
  };
  
  const setModal = async (data, condition) => {
    await setData(data);
    await setShowDelete(true);
  };

  const doSort = async (sort, sortBy) => {
    await setSortingBy(sortBy)
    await setSorting(sort);
    if (sort && sortBy) {
    await setSorting(sort);
    await setSortingBy(sortBy)
    fetchData("", sort, sortBy);
    }
  };
  const ListColumn = [
    {
        title: (
          <div style={{ display: "flex", width: "auto" }}>
          <div style={{ width: "60%" }}>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("Depot ID")}
            </span>
          </div>
          <div style={{ width: "4%", marginLeft: "40px", marginTop: "3px" }}>
            <div className={style.SortArea}>
            <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sorting === "asc"&& sortingBy ==="id" ? AscRed : DescGrey}
                  alt="asc"
                  className={sorting === "asc" && sortingBy==="id" ? "w-full cursor-pointer":"rotate-180 w-full cursor-pointer"}
                  onClick={() => {
                    doSort("asc", "id");
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sorting === "desc"&& sortingBy==="id" ? AscRed :DescGrey}
                  alt="desc"
                  className={sorting === "desc"&& sortingBy==="id" ? "rotate-180 w-full cursor-pointer":" w-full cursor-pointer"}
                  onClick={() => {
                    doSort("desc", "id");
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
        ),
        dataIndex: 'depotId',
        key: 'depotId',
        render: (depotId) => <span>{depotId}</span>,
    },
    
    {
        title: (
          <div style={{ display: "flex", width: "auto" }}>
          <div style={{ width: "60%" }}>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("Depot Name")}
            </span>
          </div>
          <div style={{ width: "3%", marginLeft: "30px", marginTop: "3px" }}>
            <div className={style.SortArea}>
            <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sorting === "asc" && sortingBy==="depot_name" ? AscRed : DescGrey}
                  alt="asc"
                  className={sorting === "asc" && sortingBy==="depot_name"? "w-full cursor-pointer":"rotate-180 w-full cursor-pointer"}
                  onClick={() => {
                    doSort("asc", "depot_name");
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sorting === "desc"&& sortingBy==="depot_name" ? AscRed : DescGrey }
                  alt="desc"
                  className={sorting === "desc"&& sortingBy==="depot_name" ? "rotate-180 w-full cursor-pointer":" w-full cursor-pointer"}
                  onClick={() => {
                    doSort("desc", "depot_name");
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
        ),
        dataIndex: 'name',
        key: 'name',
        render: (name) => <span>{name}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222] font-medium">
                {t("Depot Address 1")}
            </span>
        ),
        dataIndex: 'address',
        key: 'address',
        render: (address) => <span>{address}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222] font-medium">
                {t("Depot Phone")}
            </span>
        ),
        dataIndex: 'phone',
        key: 'phone',
        render: (phone) => <span>{phone}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222] font-medium">
                {t("USER:ACTION_FIELD")}
            </span>
        ),
        dataIndex: 'action',
        key: 'action',
        render: (action) => (action),
    },
]

  const dataSource = listData
    ? listData.map((result) => ({
        depotId: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.depot_id}
          </span>
        ),

        name: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.depot_name}
          </span>
        ),
        address: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.depot_address_1}
          </span>
        ),
        phone: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.depot_phone}
          </span>
        ),
        action: (
          <div className="flex gap-[26px]">
            <Tooltip title={t("USER:EDIT_TOOLTIP")} color="#CF0000">
              <button onClick={() => handleEdit(result?.depot_id)}>
                <img src={EditIcon} alt="edit" />
              </button>
            </Tooltip>
            <Tooltip title={t("Delete")} color="#CF0000">
              <button onClick={() => setModal(result)}>
                <img src={DeleteIcon} alt="del" />
              </button>
            </Tooltip>
            <Tooltip title={t("USER:DETAIL_TOOLTIP")} color="#CF0000">
              <button
                onClick={() => handleDetail(result?.depot_id)}
              >
                <img src={DetailIcon} alt="det" />
              </button>
            </Tooltip>
          </div>
        ),
      }))
    : null;
      
    const fetchRecommendation = async (
      page,
      limit,
      filters,
      mapping_principal_id
    ) => {
      if (filters.length >= 1) {
        let res = await doGet(`/depot-configuration/search?page=1&limit=10&filter=depot_name lk ${filters}&${param}`, token);
        setListRecommendation(res?.data?.payload?.data);
      }
    };

    const onSearchRecommendation = async (value) => {
      setIsfilter(true)
      setSearchRecommedation(value)
      if (value) {
        setSearchRecommedation(value)
        await fetchRecommendation(1,10,value)
      } 
    };
  
    const onSelectRecommendation =(data) => {
      setPage(1)
      setFilter(data)
      fetchData(data, sorting, sortingBy, 1)
      setIsfilter(false);
    };
  
    const onClearRecommendation = (e) => {
      setIsfilter(false);
      setFilter(null);
      setSearchRecommedation("");
      setListRecommendation([]);
      fetchData("", sorting, sortingBy, 1);
    };

    const options =
        listRecommendation &&
        listRecommendation.map((item) => ({
          value: item.value,
          label: item.value,
        }));

  return (
    <>
    <Delete
        data={data.updated_at}
        id={data.depot_id}
        delete={showDelete}
        title={data?.depot_name}
        url={"depot-configuration"}
        action={() => setShowDelete(false)}
        route={ROUTES.DEPOT_CONFIG.LIST}
        refresh={()=>fetchData()}
        token={token}
        param={param}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">

        <Breadcumbs
          jmlLevel={2}
          menuLevel1={`Setup`}
          menuLevel2={`Depot Configuration`}
        />

        <h1 className="font-sans-bold text-[28px] t" id="title">
          {t("Depot Configuration")}
        </h1>

        <div
          className={
            style.headerContainer + " flex justify-between items-center"
          }
        >
         <AutoComplete
                 options={options}
                 value={searchRecommendation}
                 onChange={(value) => onSearchRecommendation(value)}
                 onSelect={(value) => onSelectRecommendation(value)}
               >
              <Input
                placeholder={t("Search Depot Name")}
                suffix={<img 
                  src={filter? CloseIconSearch : SearchIcon} 
                  alt="search" 
                  onClick={filter? () => onClearRecommendation() : null}
                />}
                
                value={searchRecommendation}
                height={47}
                width={350}
                className="w-[350px] h-[47px]"
              />
            </AutoComplete>

          <Link to={ROUTES.DEPOT_CONFIG.ADD}>
            <PrimaryButton text={t("Add Depot")} prefixIcon={<AddIcon />} />
          </Link>
        </div>

        <div className={style.tableContainer}>
          <CustomTable columns={ListColumn} data={dataSource} />
          <div className={style.containerPagination + " mt-[-45px]"}>
            <CustomPaging
              idLimit="ddlrowsperpagemustselllist"
              idPagination="btnpaginationmustselllist"
              size="small"
              current={page}
              defaultCurrent={page}
              pageSize={limit}
              total={initiate && initiate?.count_data}
              pageSizeOptions={initiate && initiate?.valid_limit}
              onShowSizeChange={() => handlePagination()}
              handlePaging={(a,b) => handlePagination(a,b)}
              title={t("COMMON:ROW_PAGE")}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DepotList;
